import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.impactedViewers`;
export const INIT = `${SCOPE}/INIT`;
export const SETUP = `${SCOPE}/SETUP`;
export const SET_SELECTED_BAR = `${SCOPE}/SET_SELECTED_BAR`;
